import ExpenseSelect from 'components/ExpenseSelect';
import { ExpenseOther, isExpenseOther } from 'components/ExpenseSelect/ExpenseSelect';
import { Button, FormInput, Icon, moneyFormat } from 'modules';
import FormInputWrapper from 'modules/FormInputWrapper';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

export interface Expense {
  popis: string;
  cena: number;
}

interface ExpensesListProps {
  name: string;
  list: Expense[];
  readOnly?: boolean;
  onChange: (e: React.ChangeEvent) => void;
}

const ExpensesList = ({ name, list, readOnly, onChange }: ExpensesListProps) => {
  const [newRow] = useState(true);
  const [newRowData, setNewRowData] = useState<Expense>({
    popis: '',
    cena: 0,
  });

  const onChangeNewRowData = (e: React.ChangeEvent) => {
    const { name, value } = e.target as HTMLInputElement;
    setNewRowData({
      ...newRowData,
      [name]: value,
    });
  };

  const isValid = (): boolean => {
    return newRowData.popis !== '' && newRowData.cena > 0;
  };

  const onSaveNewRow = (): void => {
    if (isValid()) {
      const newList = [...list];
      newList.push(newRowData);
      onChange({
        target: {
          name,
          value: newList,
        },
      } as any);
      setNewRowData({
        popis: '',
        cena: 0,
      });
    }
  };

  const onDeleteRow = (index: number): void => {
    const newList = list.filter((b, i: number) => i !== index);
    onChange({
      target: {
        name,
        value: newList,
      },
    } as any);
  };

  return (
    <FormInputWrapper label={'Výdaje (max. 10 položiek)'}>
      {list.map((a: Expense, index: number) => {
        return (
          <Row key={index}>
            <Col sm={9}>
              <FormInput name="popis" value={a.popis} readOnly={true} />
            </Col>
            <Col sm={3} className="d-flex">
              <FormInput name="cena" className="text-right" value={moneyFormat(a.cena)} readOnly={true} />
              {readOnly !== true && (
                <Button
                  type="button"
                  variant="danger"
                  className="btn-input-size ml-1"
                  onClick={() => onDeleteRow(index)}
                >
                  <Icon type="times" />
                </Button>
              )}
            </Col>
          </Row>
        );
      })}

      {newRow === true && readOnly !== true && list.length < 10 && (
        <Row>
          <Col sm={isExpenseOther(newRowData.popis) ? 3 : 9}>
            <ExpenseSelect name="popis" placeholder="Vydaj" value={newRowData.popis} onChange={onChangeNewRowData} />
          </Col>
          {isExpenseOther(newRowData.popis) && (
            <Col sm={6}>
              <FormInput
                name="popis"
                value={newRowData.popis === ExpenseOther ? '' : newRowData.popis}
                onChange={onChangeNewRowData}
              />
            </Col>
          )}
          <Col sm={3} className="d-flex">
            <FormInput
              type="number"
              name="cena"
              autoComplete="off"
              placeholder="Hodnota (EUR)"
              value={newRowData.cena}
              onChange={onChangeNewRowData}
            />
            <Button
              type="button"
              variant="primary"
              disabled={!isValid()}
              className="btn-input-size ml-1"
              onClick={onSaveNewRow}
            >
              <Icon type="check" />
            </Button>
          </Col>
        </Row>
      )}
    </FormInputWrapper>
  );
};

export default ExpensesList;
